import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-vs-fly',
  imports: [RouterLink, MatButtonModule, MatIconModule],
  templateUrl: './fly.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../vs.shared.css', './fly.component.css'],
})
export class VsFlyComponent {}
